import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private toastr: ToastrService, private modalService: NgbModal
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        console.log(err.status);

        if (err.status === 401) {
          // auto logout if 401 response returned from api
        //   this.authenticationService.logout();
        //   location.reload();
          // if(err.error ==='Incorrect Username Credentials') {
          //     this.toastr.error('Credentials Incorrect, Please try again');
          // }
        } else if (err.status === 400) {
            // console.log(err)
          // this.toastr.error('An error occured');
          // this.authenticationService.logout();
          // location.reload();
          console.log(err)
          if (err.error === 'Incorrect Username Credentials') {
            this.toastr.error('Credentials Login, Please try again');
            this.modalService.dismissAll();
            // location.reload();
          } else if (err.error === 'Incorrect Password') {
            this.toastr.error('Incorrect Password, Please try again');
            this.modalService.dismissAll();

          } else {
            this.modalService.dismissAll();
            this.authenticationService.logout();
          }
          // location.reload();
        }

        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
}
